import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();

export const leadCreate = (data: unknown) => {
  return axios({
    method: "POST",
    url: "/leads",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getLeads = (params: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: "/leads",
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};

export const massDeleteLeads = (data: { leadsIds: number[] }) => {
  const url = "leads/massDelete";
  return axios({
    method: "Delete",
    url: url,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const massUpdateLeads = (data: {
  leadsIds: number[];
  fieldToUpdate: any;
}) => {
  const url = "leads/massUpdate";
  return axios({
    method: "PUT",
    url: url,
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getLeadDetails = (leadId: any) => {
  return axios({
    method: "GET",
    url: `/leads/${leadId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateLeadDetails = (leadId: any, data: any) => {
  return axios({
    method: "PUT",
    url: `/leads/${leadId}`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getUserDetails = (params?: any, moduleName?: string) => {
  return axios({
    method: "GET",
    url: `/users`,
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const uploadFile = (formData: FormData) => {
  return axios({
    method: "POST",
    url: "/leads/import",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addLeadAttachment = (leadId: number, data: any) => {
  return axios({
    method: "POST",
    url: `/leads/${leadId}/attachment`,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAttachments = (leadId: number) => {
  return axios({
    method: "GET",
    url: `/leads/${leadId}/attachments`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addLeadLinkAttachment = (leadId: number, data: any) => {
  return axios({
    method: "PUT",
    url: `/leads/${leadId}/attachment-link`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteLeadAttachment = (leadId: number, attachmentId: number) => {
  return axios({
    method: "Delete",
    url: `/leads/${leadId}/attachments/${attachmentId}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const campainAssignToLeads = (data: {
  actionScope: "multiLead_singleCampaign" | "singleLead_multiCampaign";
  leadIds: number[];
  campaignId: number;
  leadStatusInCampaign: string;
}, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/leads/addToCampaigns`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const multiplecampainsAssignToLeads = (data: {
  actionScope: "multiLead_singleCampaign" | "singleLead_multiCampaign";
  campaignIds: number[];
  leadId: number;
  leadStatusInCampaign: string;
}, moduleName?: string) => {
  const token = getAuthToken();
  return axios({
    method: "POST",
    url: `/leads/addToCampaigns`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const deleteCampaignAssign = (
  leadId: number,
  campaignLeadAssociationId: number,
  moduleName?: string
) => {
  const url = `/leads/${leadId}/campaign-associations/${campaignLeadAssociationId}`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-source-module": moduleName,
    },
  });
};
export const editCampaignStatus = (status: string, resourceIds: number[], moduleName?: string) => {
  const url = `/leads/updateMemberStatusInCampaign`;
  return axios.put(
    url,
    {
      status,
      resourceIds,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-source-module": moduleName,
      },
    }
  );
};
export const exportLeads = (format: string, leadsIds: number[]) => {
  return axios({
    method: "POST",
    url: `/leads/export?format=${format}`,
    data: { leadsIds },
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const leadApprove = (data: unknown) => {
  return axios({
    method: "POST",
    url: "/leads/approve",
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const leadLinkActivityLog = (id: any, data: unknown) => {
  return axios({
    method: "POST",
    url: `/leads/${id}/initiate`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const sendLeadSMSAndActivityLog = (id: any, data: unknown) => {
  return axios({
    method: "POST",
    url: `/leads/${id}/sendSms`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const mergeExactLeadDetails = (data: any) => {
  return axios({
    method: "PUT",
    url: `/leads/merge-duplicates`,
    data,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};